// Static RSA Public Key (must match Python exactly)
const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAvAitBppLmslJeRfl/zj+
7tiGU9MBNbWeDj9vL5TxD//KTOk7PXGGyAyWlDjoNhrHrF81oeM8rNdb/CNumaws
bIx6flZEoDe4EuzZR3e83JS8oq56AJXqFGfvcQ8Qu/IANno3/y9uA8w08/oadXkz
U+AaxUSLGVIYBDzSRMDPBvRsMoSQUiShbe0FM+idV35Pp2X5vwK0Il5DKhztaeeD
4gzo7cx9BoMQKVOZSeOwdBfnCkUPpwVYcDzMyeFJ0iVhP2WaHxHxPWHe3R8SZi/o
xce1hplgdrE92TLtRXLvyrVpDsBlGPI1UtOArNt1cxHXfdZI2yZtR4QWxYc5/8wA
vQIDAQAB
-----END PUBLIC KEY-----`;

export function getPublicKey() {
  return PUBLIC_KEY;
}